<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="top_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit1">Coretests</div>
					<div class="txt">Provide Affordable, Use-friendly & Precision diagnostic products for the world</div>
					<div class="tit2">We use modern bioengineering technology and medical research results to serve the cause of global human health!</div>
				</div>
				<img class="bg" src="../../../assets/img_public/about/qyjj/h5_block01.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="bot_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">American CorDx Union</div>
					<div class="txt">
						Core Technology Co., Ltd. is a subsidiary of the American CorDx Union group. CorDx Union (hereinafter referred to as CU) was established in 2006, serving as an international group company integrating R&D, production, marketing, and service. It has 21 subsidiaries, including Accu News, Coretests technology, Abiores, Jtests, Bonore plastics, CuPet and other brands.
					</div>
					<div class="txt">
						CU is mainly engaged in medical devices & diagnostic reagents. Its products are sold to more than 170 countries and regions, with more than 100 million users worldwide. It is widely used in clinical testing, primary medical care, on-site law enforcement, epidemic monitoring, disaster relief, home self-test, health management and other fields.
					</div>
					<div class="txt">
						CU has four research institutes all over the world, which are located in SD, California, Daxing, Beijing, Xiong'an, Hebei and Hainan Island. It continues to improve scientific and technological innovation platforms such as molecular diagnosis, colloidal gold chromatography, fluorescence immunization, biochip, recombinant protein, mRNA vaccine, pet products, battery materials, AI quality management system, etc. Diagnosis and treatment products are mainly used for infectious diseases, tumors, cardiovascular and cerebrovascular diseases, inflammation, drug abuse and other diseases.
					</div>
					<div class="txt">
						The CU manufacturing base covers a total area of 30000 square meters, and also provides high-quality services for pharmaceutical peers.
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_banner">
					<van-swipe
						class=""
						:loop="false"
						:autoplay="3000"
						indicator-color="white"
						:stop-propagation="false"
						:show-indicators="false"
						:width="185"
					>
						<van-swipe-item v-for="(value2, index2) in listData2" :key="index2" @click="showBigImg(value2.image)">
							<div class="block_main">
								<img class="img_el" lazy-load :src="value2.image" />
								<div class="tit">{{ value2.title }}</div>
								<div class="txt">{{ value2.text }}</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Our products are sold to more than 120 countries and regions, with more than 1billion users worldwide.</div>
				<img src="../../../assets/img_public/about/qyjj/h5_block03.webp" />
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_banner">
					<van-swipe
						class=""
						:loop="false"
						:autoplay="3000"
						indicator-color="white"
						:stop-propagation="false"
						:show-indicators="false"
						:width="230"
					>
						<van-swipe-item v-for="(value2, index2) in listData" :key="index2"><!-- @click="showBigImg(value2.image)" -->
							<div class="block_main">
								<img class="img_el" lazy-load :src="value2.image" />
								<div class="tit">{{ value2.title }}</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<!--块4-->
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		//
	},
	data() {
		return {
			listData: [
				{ image: require('@/assets/img_public/about/qyjj/CJ_01.webp'), title: 'Factory Layout' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_02.webp'), title: 'Laboratory Layout' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_03.webp'), title: 'R&D Department Layout' }
			],
			listData2: [
				{ image: require('@/assets/img_public/about/qyjj/img_01.webp'), title: '', text: 'Globalization' },
				{ image: require('@/assets/img_public/about/qyjj/img_02.webp'), title: '', text: 'Research and Development' },
				{ image: require('@/assets/img_public/about/qyjj/img_03.webp'), title: '', text: 'Experiment' },
				{ image: require('@/assets/img_public/about/qyjj/img_04.webp'), title: '', text: 'Retail sales' },
			]
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//查看大图
		showBigImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块4
	.block_4{
		padding: 40px 0 40px 20px;
		background-color: #F7F6F9;
		.block_banner{
			position: relative;
			.block_main{
				margin-right: 20px;
				.tit{
					padding-top: 20px;
					text-align: center;
					font-size: 18px;
				}
				.img_el{
					width: 100%;
					border-radius: 8px;
				}
			}
		}
	}
	//块3
	.block_3{
		img{
			width: 100%;
		}
		.tit{
			padding: 40px 20px 20px 20px;
			font-size: 18px;
		}
	}
	//块2
	.block_2{
		padding: 40px 0 0px 20px;
		.block_banner{
			position: relative;
			.block_main{
				margin-right: 20px;
				position: relative;
				.tit{
					position: absolute;
					bottom: 36px;
					width: 100%;
					text-align: center;
					color: #ffffff;
					font-size: 20px;
				}
				.txt{
					position: absolute;
					bottom: 36px;
					width: 100%;
					text-align: center;
					color: #ffffff;
					font-size: 18px;
				}
				.img_el{
					width: 100%;
					border-radius: 8px;
				}
			}
		}
	}
	//块1
	.block_1{
		.bot_box{
			padding: 40px 20px;
			border-bottom: 1px solid #E3E1E6;
			.txt{
				padding-bottom: 10px;
				line-height: 1.8;
				font-size: 16px;
			}
			.tit{
				padding-bottom: 24px;
				font-size: 24px;
				font-weight: bold;
				color: #A50073;
				text-align: center;
			}
		}
		img.bg{
			width: 100%;
		}
		.top_box{
			padding: 40px 20px;
			text-align: center;
			.tit2{
				font-size: 18px;
				font-weight: bold;
				color: #A50073;
			}
			.txt{
				padding: 10px 0 10px 0;
				font-size: 16px;
			}
			.tit1{
				font-size: 30px;
				font-weight: bold;
			}
		}
	}
}
</style>